import React, { useState, useEffect } from "react";
import { FloatingLabel } from "flowbite-react";

const AddVillagesForm = ({ village, compensationsId }) => {
  console.log(compensationsId);
  const [formData, setFormData] = useState({
    VillageCode: "",
    VillageNameHindi: "",
    InitialCompensationId: compensationsId,
    km: "",
    ShajraFile: null,
    ConsentFile: null,
    VillageRateList: null,
  });

  const [initialVillages, setInitialVillages] = useState([]);
  const fetchInitialVillages = async () => {
    try {
      const response = await fetch(
        `https://backurrda.sarmar.co.in/api/DetailsInsert/CompensationVillageDetailsGet?compensationId=${compensationsId}`
      );
      if (response.ok) {
        const data = await response.json();
        setInitialVillages(data); // Update state with fetched data
        console.log('object')
      } else {
        console.error(
          "Failed to fetch villages. HTTP Status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching villages:", error);
    }
  };

  // Move this useEffect after moving fetchInitialVillages outside
  useEffect(() => {
    fetchInitialVillages();
  }, [compensationsId]);

  // const handleChange = (e) => {
  //   debugger
  //   const { name, value, files } = e.target;
  //   if (files) {
  //     setFormData({ ...formData, [name]: files[0] });
  //   } else {
  //     setFormData({ ...formData, [name]: value });
  //   }
  // };

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files && files.length > 0) {
      setFormData({ ...formData, [name]: files[0] });
      e.target.value = null; // Allow reselecting the same file
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async () => {
    debugger;
    const data = new FormData();

    data.append("VillageCode", formData.VillageCode);
    data.append("VillageNameHindi", formData.VillageNameHindi);
    data.append("InitialCompensationId", formData.InitialCompensationId);
    data.append("km", formData.km);
    // data.append("ShajraFile", formData.ShajraFile);
    // data.append("ConsentFile", formData.ConsentFile);
    // data.append("VillageRateList", formData.VillageRateList);
    if (formData.ShajraFile) {
      data.append("ShajraFile", formData.ShajraFile);
    }

    if (formData.ConsentFile) {
      data.append("ConsentFile", formData.ConsentFile);
    }

    if (formData.VillageRateList) {
      data.append("VillageRateList", formData.VillageRateList);
    }

    try {
      const response = await fetch(
        "https://backurrda.sarmar.co.in/api/DetailsInsert/VillageDetailsInsert",
        {
          method: "POST",
          body: data,
        }
      );
      if (response.ok) {
        // alert('Data submitted successfully!');

        // Refresh the villages list
        fetchInitialVillages();
        setFormData({
          VillageCode: "",
          VillageNameHindi: "",
          InitialCompensationId: compensationsId,
          km: "",
          ShajraFile: "",
          ConsentFile: "",
          VillageRateList: "",
        });
      } else {
        alert("Failed to submit data.");
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  const getFileUrl = (filePath) => {
    if (!filePath) return null; // Return null if the file path is empty
    const fileName = filePath.split("\\").pop(); // Extract file name
    return `https://backurrda.sarmar.co.in/api/Files/view/${fileName}`;
  };

  return (
    <div className="p-4">
      <h2 className="text-lg font-bold mb-4">Add Villages</h2>
      <hr />

      <div>
        <div className="mb-4 w-full">
          <div className="grid grid-cols-3 gap-4 p-1">
          <div className="relative col-span-2">
              <select
                id="floating_select"
                className="block px-2.5 pb-2.5 pt-4 w-full text-sm text-gray-900 bg-gray-50 dark:bg-gray-700 border-0 border-b-2 border-gray-300 appearance-none dark:text-white dark:border-gray-600 focus:outline-none focus:ring-0 focus:border-blue-600 peer"
                value={JSON.stringify({
                  VillageCode: formData.VillageCode,
                  VillageNameHindi: formData.VillageNameHindi,
                })}
                onChange={(e) => {
                  const selectedValue = JSON.parse(e.target.value);
                  setFormData({
                    ...formData,
                    VillageCode: selectedValue.VillageCode,
                    VillageNameHindi: selectedValue.VillageNameHindi,
                  });
                }}
              >
                <option value="">Choose village</option>
                {village.map((item) => (
                  <option
                    key={item.VillageCode}
                    value={JSON.stringify({
                      VillageCode: item.VillageCode,
                      VillageNameHindi: item.VillageName,
                    })}
                  >
                    {item.VillageName}
                  </option>
                ))}
              </select>
              <label
                htmlFor="floating_select"
                className="absolute text-sm text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] left-2.5 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4"
              >
                Village
              </label>
            </div>

            <FloatingLabel
              id="km"
              name="km"
              variant="standard"
              type="number"
              label="KM"
              value={formData.km}
              onChange={handleChange}
            />

            <div className="flex items-center justify-center w-full">
              <label
                htmlFor="ShajraFile"
                className="flex flex-col items-center justify-center w-full h-10 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-white hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-200 dark:hover:bg-gray-400"
              >
                <div className="flex items-center justify-center">
                  <p className="text-xs text-gray-500 dark:text-gray-400 mr-2">
                    📄 Village Shajra
                  </p>
                  <svg
                    className="w-4 h-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                </div>
                <input
                  id="ShajraFile"
                  name="ShajraFile"
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={handleChange}
                  className="hidden"
                />
              </label>
            </div>

            <div className="flex items-center justify-center w-full">
              <label
                htmlFor="ConsentFile"
                className="flex flex-col items-center justify-center w-full h-10 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-white hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-200 dark:hover:bg-gray-400"
              >
                <div className="flex items-center justify-center">
                  <p className="text-xs text-gray-500 dark:text-gray-400 mr-2">
                    📄 Consent File
                  </p>
                  <svg
                    className="w-4 h-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                </div>
                <input
                  id="ConsentFile"
                  name="ConsentFile"
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={handleChange}
                  className="hidden"
                />
              </label>
            </div>
            <div className="flex items-center justify-center w-full">
              <label
                htmlFor="VillageRateList"
                className="flex flex-col items-center justify-center w-full h-10 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 dark:bg-white hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-200 dark:hover:bg-gray-400"
              >
                <div className="flex items-center justify-center">
                  <p className="text-xs text-gray-500 dark:text-gray-400 mr-2">
                    📄 Village Rate List
                  </p>
                  <svg
                    className="w-4 h-4 text-gray-500 dark:text-gray-400"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 20 16"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                    />
                  </svg>
                </div>
                <input
                  id="VillageRateList"
                  name="VillageRateList"
                  type="file"
                  accept=".pdf,.doc,.docx"
                  onChange={handleChange}
                  className="hidden"
                />
              </label>
            </div>
            <button
              onClick={handleSubmit}
              className="w-1/2 placeholder:mt-0 bg-blue-500 text-white px-4 py-2 rounded"
            >
              Add
            </button>
          </div>
        </div>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full table-auto border-collapse border border-gray-200 text-center">
          <thead className="bg-gray-100 text-sm">
            <tr>
              <th className="border px-4 py-2">Name Of Village</th>
              <th className="border px-4 py-2">Kilometer</th>
              <th className="border px-4 py-2">Shajra</th>
              <th className="border px-4 py-2">Pradhan Consent</th>
              <th className="border px-4 py-2">Village Rate List</th>
            </tr>
          </thead>
          <tbody className="text-xs">
            {initialVillages.map((village) => (
              <tr key={village.Id} className="hover:bg-gray-50">
                <td className="border px-4 py-2">{village.VillageNameHindi}</td>
                <td className="border px-4 py-2">{village.Km}</td>
                <td className="border px-4 py-2">
                  {village.Shajra ? (
                    <a
                      href={getFileUrl(village.Shajra)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:underline"
                    >
                      View Shajra
                    </a>
                  ) : (
                    "No File"
                  )}
                </td>
                <td className="border px-4 py-2">
                  {village.Consent ? (
                    <a
                      href={getFileUrl(village.Consent)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:underline"
                    >
                      View Consent
                    </a>
                  ) : (
                    "No File"
                  )}
                </td>
                <td className="border px-4 py-2">
                  {village.VillageRateList ? (
                    <a
                      href={getFileUrl(village.VillageRateList)}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-500 hover:underline"
                    >
                      View Consent
                    </a>
                  ) : (
                    "No File"
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AddVillagesForm;
